import { Info } from 'lucide-react';
import { ProspectIntelPanel } from './ProspectIntelPanel';
import { CreateEntityForm } from './CreateEntityForm';
import { ThreadParticipantsPicker } from './ThreadParticipantsPicker';
import type { useProspectDraft } from './useProspectDraft';

interface Props {
  draft: ReturnType<typeof useProspectDraft>;
  pipelines: { id: string; name: string }[];
  pipelineId: string;
  onPipelineChange: (id: string) => void;
}

/** Corpo del tab "Crea nuovo": anteprima dei dati trovati, form e partecipanti. */
export function CreateNewPanel({ draft, pipelines, pipelineId, onPipelineChange }: Props) {
  return (
    <div className="space-y-4 mail-link-section">
      {draft.matches?.company && (
        <div className="flex items-start gap-2 rounded-xl border border-[#2383E2]/25 bg-[rgba(35,131,226,0.06)] p-3 text-xs text-[#37352F] dark:text-white/90 leading-relaxed">
          <Info className="h-3.5 w-3.5 text-[#2383E2] flex-shrink-0 mt-px" />
          <span>
            {draft.matches.person
              ? <>
                  <b>{draft.matches.company.business_name}</b> e <b>{draft.matches.person.business_name}</b> sono
                  gia' in anagrafica: verranno solo collegati a questa email.
                </>
              : <>
                  <b>{draft.matches.company.business_name}</b> e' gia' in anagrafica: verra' creata solo la
                  persona e collegata a essa.
                </>}
          </span>
        </div>
      )}

      <ProspectIntelPanel
        candidates={draft.siteCandidates}
        selected={draft.selectedSite}
        onSelect={draft.setSelectedSite}
        loading={draft.analyzing}
        foundCount={Object.keys(draft.companyDraft).length}
        socialLinks={draft.socialLinks}
      />

      <CreateEntityForm
        kind={draft.kind}
        onKindChange={draft.setKind}
        company={draft.companyValues}
        companyDraft={draft.companyDraft}
        onCompanyChange={draft.setCompanyField}
        person={draft.person}
        onPersonChange={draft.setPersonField}
        pipelines={pipelines}
        pipelineId={pipelineId}
        onPipelineChange={onPipelineChange}
      />

      {draft.kind !== 'person' && (
        <ThreadParticipantsPicker
          participants={draft.participants}
          selected={draft.extraPeople}
          onToggle={draft.toggleExtraPerson}
        />
      )}
    </div>
  );
}
